"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _product = require("@/api/product");
var _logistics = require("@/api/logistics");
var _marketing = require("@/api/marketing");
var _validate = require("@/utils/validate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
//import CreatTemplates from '@/views/systemSetting/logistics/shippingTemplates/creatTemplates';
var defaultObj = {
  image: '',
  images: [],
  headImg: '',
  title: '',
  ficti: 0,
  unitName: '',
  sort: 0,
  tempId: '',
  attrValue: [{
    image: '',
    price: 0,
    cost: 0,
    otPrice: 0,
    stock: 0,
    barCode: '',
    weight: 0,
    volume: 0
  }],
  attr: [],
  selectRule: '',
  descInfo: '',
  specType: false,
  id: 0,
  thirdCatId: '',
  thirdCatIdList: [],
  brandId: 0,
  qualificationPics: '',
  qualificationPicsList: []
};
var objTitle = {
  price: {
    title: '商品价'
  },
  cost: {
    title: '成本价'
  },
  otPrice: {
    title: '划线价'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编码'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  }
};
var _default = exports.default = {
  name: 'creatSeckill',
  components: {
    Tinymce: _index.default
  },
  data: function data() {
    return {
      props: {
        children: 'secondCatList',
        label: 'secondCatName',
        value: 'secondCatId',
        multiple: true,
        emitPath: false
      },
      propsCatId: {
        emitPath: true
      },
      options: [],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < new Date().setTime(new Date().getTime() - 3600 * 1000 * 24);
        }
      },
      props2: {
        children: 'child',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false
      },
      grid2: {
        xl: 8,
        lg: 10,
        md: 12,
        sm: 24,
        xs: 24
      },
      currentTab: 0,
      formThead: Object.assign({}, objTitle),
      formValidate: Object.assign({}, defaultObj),
      loading: false,
      fullscreenLoading: false,
      shippingList: [],
      // 运费模板
      ruleValidate: {
        primaryProductId: [{
          required: true,
          message: '请选择商品',
          trigger: 'change'
        }],
        title: [{
          required: true,
          message: '请输入商品标题',
          trigger: 'blur'
        }],
        attrValue: [{
          required: true,
          message: '请选择商品属相',
          trigger: 'change',
          type: 'array',
          min: '1'
        }],
        ficti: [{
          required: true,
          message: '请输入已售数量',
          trigger: 'blur'
        }],
        unitName: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }],
        images: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }],
        specType: [{
          required: true,
          message: '请选择商品规格',
          trigger: 'change'
        }],
        thirdCatIdList: [{
          required: true,
          message: '请选择商品类目',
          trigger: 'change'
        }]
      },
      manyTabDate: {},
      manyTabTit: {},
      attrInfo: {},
      tempRoute: {},
      multipleSelection: [],
      primaryProductId: 0,
      productQualificationType: 0,
      //商品资质类型，0不需要，1必填，2选填
      productQualification: '',
      // 资质说明
      ManyAttrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 多规格
      brandIdList: [],
      dialogVisible: false,
      isDisabled: this.$route.params.isDisabled === '1' ? true : false
    };
  },
  computed: {
    attrValue: function attrValue() {
      var obj = Object.assign({}, defaultObj.attrValue[0]);
      delete obj.image;
      return obj;
    }
  },
  created: function created() {
    this.$watch('formValidate.attr', this.watCh);
    this.tempRoute = Object.assign({}, this.$route);
    if (!JSON.parse(sessionStorage.getItem('videoCategory'))) this.getCatList();
    if (!JSON.parse(sessionStorage.getItem('draftBrand'))) this.getDraftBrandlist();
  },
  mounted: function mounted() {
    this.formValidate.images = [];
    if (this.$route.params.id) {
      this.currentTab = 1;
      this.setTagsViewTitle();
      this.getInfo();
    }
    this.getShippingList();
    this.options = JSON.parse(sessionStorage.getItem('videoCategory'));
    this.brandIdList = JSON.parse(sessionStorage.getItem('draftBrand'));
  },
  methods: {
    handleChangesModel: function handleChangesModel(e) {
      var obj = this.$refs['demoCascader'].getCheckedNodes();
      this.productQualificationType = obj.length > 0 ? obj[0].data.productQualificationType : 0;
      this.productQualification = obj.length > 0 ? obj[0].data.productQualification : '';
      this.dialogVisible = false;
    },
    handleChanges: function handleChanges(e) {
      if (!this.isDisabled) this.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 类目；
    getCatList: function getCatList() {
      var _this2 = this;
      (0, _marketing.catListApi)().then(function (res) {
        _this2.options = res;
        sessionStorage.setItem('videoCategory', JSON.stringify(res));
      });
    },
    // 类目；
    getDraftBrandlist: function getDraftBrandlist() {
      var _this3 = this;
      (0, _marketing.draftBrandlistApi)().then(function (res) {
        _this3.brandIdList = res;
        sessionStorage.setItem('draftBrand', JSON.stringify(res));
      });
    },
    watCh: function watCh(val) {
      var tmp = {};
      var tmpTab = {};
      this.formValidate.attr.forEach(function (o, i) {
        // tmp['value' + i] = { title: o.attrName }
        // tmpTab['value' + i] = ''
        tmp[o.attrName] = {
          title: o.attrName
        };
        tmpTab[o.attrName] = '';
      });
      this.manyTabTit = tmp;
      this.manyTabDate = tmpTab;
      this.formThead = Object.assign({}, this.formThead, tmp);
    },
    handleRemove: function handleRemove(i, val) {
      if (val === 'images') {
        this.formValidate.images.splice(i, 1);
      } else {
        this.formValidate.qualificationPicsList.splice(i, 1);
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i) {
      var _this = this;
      if (_this.isDisabled) return;
      if (tit === '3') return this.$message.warning('正在建造');
      this.fullscreenLoading = true;
      // productDetailApi(id).then(async res => {
      this.$modalUpload(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(img) {
          var result, _result, _result2;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!(img == false)) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2, _this.fullscreenLoading = false);
              case 1:
                if (tit === '1' && !num) {
                  _this.formValidate.image = img[0].sattDir;
                  _this.ManyAttrValue[0].image = img[0].sattDir;
                }
                if (!(tit === '2' && !num)) {
                  _context.n = 4;
                  break;
                }
                if (!(img.length > 5 || img.length + _this.formValidate.images.length > 5)) {
                  _context.n = 2;
                  break;
                }
                return _context.a(2, this.$message.warning('最多选择5张图片！'));
              case 2:
                _context.n = 3;
                return _this.getShopImgUpload(img, []);
              case 3:
                result = _context.v;
                result.map(function (item) {
                  _this.formValidate.images.push(item.img);
                });
                _this.fullscreenLoading = false;
              case 4:
                if (!(tit === '1' && num === 'duo')) {
                  _context.n = 6;
                  break;
                }
                _context.n = 5;
                return _this.getImgData(img[0].sattDir);
              case 5:
                _result = _context.v;
                _this.ManyAttrValue[i].image = _result;
                _this.fullscreenLoading = false;
              case 6:
                if (!(tit === '3')) {
                  _context.n = 9;
                  break;
                }
                if (!(img.length > 5 || img.length + _this.formValidate.qualificationPicsList.length > 5)) {
                  _context.n = 7;
                  break;
                }
                return _context.a(2, this.$message.warning('最多选择5张图片！'));
              case 7:
                _context.n = 8;
                return _this.getShopImgUpload(img, []);
              case 8:
                _result2 = _context.v;
                _result2.map(function (item) {
                  _this.formValidate.qualificationPicsList.push(item.img);
                });
                _this.fullscreenLoading = false;
              case 9:
                return _context.a(2);
            }
          }, _callee, this);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), tit, 'content');
    },
    changeGood: function changeGood() {
      var _this = this;
      this.$modalGoodList(function (row) {
        _this.formValidate.image = row.image;
        _this.primaryProductId = row.id;
      });
    },
    handleSubmitNest1: function handleSubmitNest1() {
      if (!this.formValidate.image) {
        return this.$message.warning('请选择商品！');
      } else {
        this.currentTab++;
        if (!this.$route.params.id) this.getProdect(this.primaryProductId);
      }
    },
    filerMerCateList: function filerMerCateList(treeData) {
      return treeData.map(function (item) {
        if (!item.child) {
          item.disabled = true;
        }
        item.label = item.name;
        return item;
      });
    },
    // 运费模板；
    getShippingList: function getShippingList() {
      var _this4 = this;
      (0, _logistics.shippingTemplatesList)(this.tempData).then(function (res) {
        _this4.shippingList = res.list;
      });
    },
    // 运费模板
    addTem: function addTem() {
      this.$refs.addTemplates.dialogVisible = true;
      this.$refs.addTemplates.getCityList();
    },
    // 商品详情
    getInfo: function getInfo() {
      if (!this.$route.params.id) {
        this.getProdect(this.primaryProductId);
      } else {
        this.getDraftProdect(this.$route.params.id);
      }
    },
    getProdect: function getProdect(id) {
      var _this5 = this;
      this.fullscreenLoading = true;
      (0, _product.productDetailApi)(id).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          var info;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                info = res;
                _this5.formValidate = {
                  image: _this5.$selfUtil.setDomain(info.image),
                  images: JSON.parse(info.sliderImage),
                  title: info.name,
                  sort: info.sort,
                  tempId: info.tempId,
                  attr: info.attr,
                  attrValue: info.attrValue,
                  unitName: info.unitName,
                  // selectRule: info.selectRule,
                  descInfo: info.content,
                  specType: info.specType,
                  primaryProductId: info.id,
                  ficti: info.ficti,
                  qualificationPicsList: [],
                  thirdCatIdList: [],
                  thirdCatId: 0,
                  brandId: '',
                  id: 0
                };
                if (info.specType) {
                  info.attrValue.forEach(function (row) {
                    row.attrValue = JSON.parse(row.attrValue);
                    for (var attrValueKey in row.attrValue) {
                      row[attrValueKey] = row.attrValue[attrValueKey];
                    }
                  });
                  _this5.$nextTick(function () {
                    info.attrValue.forEach(function (row) {
                      row.image = _this5.$selfUtil.setDomain(row.image);
                      _this5.$refs.multipleTable.toggleRowSelection(row, true);
                      _this5.$set(row, 'checked', true);
                    });
                  });
                  _this5.ManyAttrValue = info.attrValue;
                  _this5.multipleSelection = info.attrValue;
                } else {
                  _this5.ManyAttrValue = info.attrValue;
                  _this5.formValidate.attr = [];
                }
                _this5.getShopImg(info.sliderImage, info.attrValue);
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this5.fullscreenLoading = false;
      });
    },
    /**
     * 视频号转图片路径
     * @param sliderImage轮播图, attrValue规格
     */
    getShopImg: function () {
      var _getShopImg = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(sliderImage, attrValue) {
        var _this6 = this;
        var imgList, attrs, ShopImg, result;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              imgList = _toConsumableArray(JSON.parse(sliderImage));
              attrValue.map(function (item) {
                return imgList.push(item.image);
              });
              attrs = _toConsumableArray(new Set(imgList));
              ShopImg = [];
              attrs.map(function (item) {
                ShopImg.push({
                  key: item,
                  img: item
                });
              });
              _context3.n = 1;
              return this.getShopImgUpload(ShopImg, []);
            case 1:
              result = _context3.v;
              this.formValidate.images = this.formValidate.images.map(function (item, index) {
                if (result[index].key && item === result[index].key) {
                  return result[index].img;
                } else {
                  _this6.formValidate.images.splice(index, 1);
                }
              });
              this.ManyAttrValue.map(function (item, index) {
                result.map(function (items, index) {
                  if (items.key && item.image === items.key) {
                    return item.image = items.img;
                  }
                  // else {
                  //   this.ManyAttrValue.splice(index, 1);
                  // }
                });
              });
              this.fullscreenLoading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getShopImg(_x3, _x4) {
        return _getShopImg.apply(this, arguments);
      }
      return getShopImg;
    }(),
    getShopImgUpload: function () {
      var _getShopImgUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(attrs, arr) {
        var key, res, _t, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _t = _regeneratorKeys(attrs);
            case 1:
              if ((_t2 = _t()).done) {
                _context4.n = 3;
                break;
              }
              key = _t2.value;
              _context4.n = 2;
              return this.getImgData(attrs[key].img || attrs[key].sattDir);
            case 2:
              res = _context4.v;
              arr.push({
                key: attrs[key].img || attrs[key].imgsattDir,
                img: res
              });
              _context4.n = 1;
              break;
            case 3:
              return _context4.a(2, arr);
          }
        }, _callee4, this);
      }));
      function getShopImgUpload(_x5, _x6) {
        return _getShopImgUpload.apply(this, arguments);
      }
      return getShopImgUpload;
    }(),
    /**
     * 视频号转图片路径请求接口
     * @param imgUrl
     * @returns {Promise<any>}
     */
    getImgData: function getImgData(imgUrl) {
      var _this7 = this;
      return new Promise(function (resolve, reject) {
        (0, _marketing.shopImgUploadApi)({
          imgUrl: imgUrl,
          respType: 1,
          uploadType: 1
        }).then(function (res) {
          if (res.errcode > 0) {
            _this7.fullscreenLoading = false;
            _this7.$message.error(res.errmsg);
            resolve('');
          } else {
            resolve(res.img_info.temp_img_url);
          }
        });
      });
    },
    getDraftProdect: function getDraftProdect(id) {
      var _this8 = this;
      this.fullscreenLoading = true;
      (0, _marketing.draftInfoApi)(id).then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(res) {
          var info;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                info = res;
                _this8.formValidate = {
                  images: JSON.parse(info.headImg),
                  title: info.title,
                  unitName: info.unitName,
                  tempId: info.tempId,
                  attr: JSON.parse(info.attr),
                  descInfo: info.descInfo,
                  specType: info.specType,
                  primaryProductId: info.primaryProductId,
                  ficti: info.ficti,
                  thirdCatIdList: [info.catInfo.firstCatId, info.catInfo.secondCatId, info.catInfo.thirdCatId],
                  thirdCatId: info.thirdCatId,
                  brandId: info.brandId,
                  qualificationPicsList: JSON.parse(info.qualificationPics) || [],
                  id: info.id,
                  productId: info.productId
                };
                if (info.specType) {
                  _this8.ManyAttrValue = JSON.parse(info.attrValue);
                  _this8.$nextTick(function () {
                    _this8.ManyAttrValue.forEach(function (item, index) {
                      item.attrValue = JSON.parse(item.attrValue);
                      for (var attrValueKey in item.attrValue) {
                        item[attrValueKey] = item.attrValue[attrValueKey];
                      }
                      if (item.id) {
                        _this8.$set(item, 'price', item.price);
                        _this8.$nextTick(function () {
                          _this8.$refs.multipleTable.toggleRowSelection(item, true);
                        });
                      }
                    });
                  });
                } else {
                  _this8.ManyAttrValue = JSON.parse(info.attrValue);
                  _this8.formValidate.attr = [];
                }
                _this8.fullscreenLoading = false;
              case 1:
                return _context5.a(2);
            }
          }, _callee5);
        }));
        return function (_x7) {
          return _ref3.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this8.fullscreenLoading = false;
      });
    },
    handleSubmitNest2: function handleSubmitNest2(name) {
      var _this9 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this9.formValidate.specType && _this9.multipleSelection.length === 0) return _this9.$message.warning('请填选择至少一个商品属性！');
          if (_this9.productQualificationType === 1 && _this9.formValidate.qualificationPicsList.length === 0) return _this9.$message.warning('该类目必须上传商品资质图片，请上传！');
          _this9.currentTab++;
        } else {
          return false;
        }
      });
    },
    // 提交
    handleSubmit: (0, _validate.Debounce)(function (name) {
      var _this0 = this;
      if (!this.formValidate.specType) {
        // this.formValidate.attr = []
        this.formValidate.attrValue = this.ManyAttrValue;
      } else {
        // this.multipleSelection.forEach((row) => {
        //   this.$set(row, 'checked', true)
        // });
        this.formValidate.attrValue = this.multipleSelection;
        this.formValidate.attrValue.forEach(function (item) {
          item.attrValue = JSON.stringify(item.attrValue);
        });
      }
      this.formValidate.thirdCatId = this.formValidate.thirdCatIdList[2];
      this.formValidate.headImg = JSON.stringify(this.formValidate.images);
      this.formValidate.qualificationPics = JSON.stringify(this.formValidate.qualificationPicsList);
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this0.fullscreenLoading = true;
          _this0.loading = true;
          _this0.$route.params.id ? (0, _marketing.draftUpdateApi)(_this0.formValidate).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
            return _regenerator().w(function (_context6) {
              while (1) switch (_context6.n) {
                case 0:
                  _this0.fullscreenLoading = false;
                  _this0.$message.success('编辑成功');
                  _this0.$router.push({
                    path: '/videoChannel/draftList'
                  });
                  _this0.$refs[name].resetFields();
                  _this0.formValidate.images = [];
                  _this0.formValidate.qualificationPics = [];
                  _this0.loading = false;
                case 1:
                  return _context6.a(2);
              }
            }, _callee6);
          }))).catch(function () {
            _this0.fullscreenLoading = false;
            _this0.loading = false;
          }) : (0, _marketing.videoAddApi)(_this0.formValidate).then(/*#__PURE__*/function () {
            var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(res) {
              return _regenerator().w(function (_context7) {
                while (1) switch (_context7.n) {
                  case 0:
                    _this0.fullscreenLoading = false;
                    _this0.$message.success('新增成功');
                    _this0.$router.push({
                      path: '/videoChannel/draftList'
                    });
                    _this0.$refs[name].resetFields();
                    _this0.formValidate.images = [];
                    _this0.formValidate.qualificationPics = [];
                    _this0.loading = false;
                  case 1:
                    return _context7.a(2);
                }
              }, _callee7);
            }));
            return function (_x8) {
              return _ref5.apply(this, arguments);
            };
          }()).catch(function () {
            _this0.fullscreenLoading = false;
            _this0.loading = false;
          });
        } else {
          if (!_this0.formValidate.storeName || !_this0.formValidate.unitName || !_this0.formValidate.store_info || !_this0.formValidate.image || !_this0.formValidate.images) {
            _this0.$message.warning('请填写完整商品信息！');
          }
        }
      });
    }),
    handleSubmitUp: function handleSubmitUp() {
      this.productQualificationType = 0;
      //this.formValidate.thirdCatIdList = [];
      if (this.currentTab-- < 0) this.currentTab = 0;
    },
    setTagsViewTitle: function setTagsViewTitle() {
      var title = this.isDisabled ? '查看视频号商品' : '编辑视频号商品';
      var route = Object.assign({}, this.tempRoute, {
        title: "".concat(title, "-").concat(this.$route.params.id)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item, val) {
      var _newItems;
      e.dataTransfer.effectAllowed = 'move';
      if (item === this.dragging) {
        return;
      }
      var newItems = [];
      if (val === 'images') {
        newItems = _toConsumableArray(this.formValidate.images);
      } else {
        newItems = _toConsumableArray(this.formValidate.qualificationPicsList);
      }
      var src = newItems.indexOf(this.dragging);
      var dst = newItems.indexOf(item);
      (_newItems = newItems).splice.apply(_newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
      if (val === 'images') {
        this.formValidate.images = newItems;
      } else {
        this.formValidate.qualificationPicsList = newItems;
      }
    }
  }
};